import { IPostMessageAction, IPostMessageOptions } from "types/iframe";

export const mustCatchPostMessage = (options: IPostMessageOptions, data: IPostMessageAction) => {
    return options.action === data.action && options.entity === data.entity
}